import AbstractListResource from './abstract/abstract-list-resource';
import {Resource, ActionType} from 'sdk/src/defines';
import Locale from './items/locale';
import {DropDownItem} from '../utility/types';
import {CallingCodeToCountryCodeMap} from '../utility/maps';

class Locales extends AbstractListResource<Locale> {
    public resourceType: Resource = Resource.LOCALES;

    public resourceItemClass: typeof Locale = Locale;

    public allowedActions: ActionType[] = [
        ActionType.LIST,
        ActionType.UPDATE,
        ActionType.DELETE,
        ActionType.CREATE,
        ActionType.DROP_DOWN_LIST,
    ];

    public availableLanguages(): DropDownItem[] {
        if (!this.isInitialized()) {
            return [];
        }

        const result: DropDownItem[] = [];
        this.getItems().forEach((item: Locale) => {
            result.push({
                value: item.language,
                label: Locale.getLanguageLabelByCode(item.language),
            });
        });

        if (!result.length) {
            result.push({
                value: 'en',
                label: Locale.getLanguageLabelByCode('en'),
            });
        }

        return result;
    }

    public static getPhonesCountryCodesForDropDown(empty?: string): DropDownItem[] {
        const result: DropDownItem[] = [];

        if (empty) {
            result.push({
                label: empty,
                value: undefined,
            });
        }

        Object.keys(CallingCodeToCountryCodeMap).forEach((code: string) => {
            const codePoints: number[] = CallingCodeToCountryCodeMap[code]
                .toUpperCase()
                .split('')
                .map((char: string) =>  127397 + char.charCodeAt(0));

            result.push({
                value: CallingCodeToCountryCodeMap[code],
                label: `${String.fromCodePoint(...codePoints)} +${code} (${CallingCodeToCountryCodeMap[code]})`,
            });
        });

        return result;
    }
}

export {Locales, Locale};

export default new Locales();
